import ContractsMileageDetailsRequest from "../../../../api/raily/contracts/mileage/details/contracts-mileage-details.request";
import ContractsMileageDetailsParamsParams from "./contracts-mileage-details-params";

const create = (
  params: ContractsMileageDetailsParamsParams,
): ContractsMileageDetailsRequest => {
  return {
    contractUuid: params.contractUuid,
  };
};

const contractsMileageDetailsParamsFactory = {
  create,
};

export default contractsMileageDetailsParamsFactory;
